<button
	id="{{ name }}Btn"
	class="btn {{ btnClass }} {{ size }} {{ customClass }} aut-{{ name }}-btn"
	[ngClass]="{ submitting: isSubmitting, 'no-transform': noTransform }"
	type="{{ isSubmit ? 'submit' : 'button' }}"
	[disabled]="isDisabled || isSubmitting"
	[attr.aria-label]="ariaLabel"
	(click)="handleOnClick($event)">
	{{ label }}
	<ng-content></ng-content>
	@if (icon && !isSubmitting) {
		<ea-icon class="icon" [name]="icon"> </ea-icon>
	}
	@if (isSubmitting) {
		<ea-button-spinner [isSubmitting]="isSubmitting"></ea-button-spinner>
	}
</button>
